import { Alert, Col, Row } from "react-bootstrap";
import { Video } from "../../interfaces/video";
import { useEffect, useState } from "react";
import { VideoSelector } from "./video-selector";
import { t } from "i18next";
import { h } from "@fullcalendar/core/preact";

interface EntityVideosProps {
    entity_id: number;
    label: string;
    alert: string;
    videos: Video[];
    onChange: CallableFunction;
    updateEnebled: boolean;
}

export function EntityVideos(props: EntityVideosProps) {
    const [selectedVideos, setSelectedVideos] = useState<number[]>();
    const [showVideoSelector, setShowVideosSelector] = useState(false);

    useEffect(() => {
        setSelectedVideos(props.videos.map((v: Video) => { return v.id; }));
    }, []);

    const handleVideos = (event: any) => {
        event.preventDefault();
        setSelectedVideos(selectedVideos);
        setShowVideosSelector(true);
    }

    const handleVideosAccept = (videos: number[]) => {
        setSelectedVideos(videos);
        props.onChange(props.entity_id, videos);
        setShowVideosSelector(false);
    }

    const handleVideosReject = () => {
        setShowVideosSelector(false);
    }

    return (
        <div className="entity-videos">
            { props.updateEnebled &&
                <a className="admin-add-new" href="#" onClick={ handleVideos }>
                    <i className="bi bi-plus-circle"></i> { t("add_videos") }
                </a>
            }
            { props.label.length &&
                <div className="label">
                    <span>{ props.label }</span>
                </div>
            }
            <div className="value">
                {
                    props.alert && props.videos.length == 0 &&
                    <Alert key="info" variant="info">
                        { props.alert }
                    </Alert>
                }
                {
                    props.videos.length > 0 &&
                    <Row key={ 'row-videos-' + props.entity_id }>
                        { props.videos.map((v: Video) => {
                            return (
                                <Col key={ 'col-videos-' + v.id } xs={ 12 } lg={6} xl={4}>
                                    <div className="video-card">
                                        <div className="heading">
                                            <div className="media">
                                                { v.media.length > 0 &&
                                                    <video controls>
                                                        <source src={ v.media[0].url } />
                                                    </video>
                                                }
                                            </div>
                                            <div className="meta">
                                                <div className="name">
                                                    { v.name }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            )})
                        }
                    </Row>
                }
            </div>
            { showVideoSelector && props.updateEnebled &&
                <VideoSelector videos={ props.videos } acceptCallback={ handleVideosAccept } rejectCallback={ handleVideosReject} />
            }
        </div>
    );
}